import { styled } from '@mui/system'
import { colors, fontSizes, MERCH_CARD_SIZE } from '../../consts'

type ItemProps = {
  uiTheme?: 'light' | 'dark'
  size: 'normal' | 'small'
}

export const ShopConOuter = styled('div')<ItemProps>(({ size, theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  width: MERCH_CARD_SIZE[size].desktop,
  [theme.breakpoints.between('md', 'lg')]: {
    width: MERCH_CARD_SIZE[size].tablet,
  },
  [theme.breakpoints.between('sm', 'md')]: {
    width: MERCH_CARD_SIZE[size].mobile,
  },
  [theme.breakpoints.down('sm')]: {
    width: MERCH_CARD_SIZE[size].smMobile,
  },
}))

export const ShopConInner = styled('a')<ItemProps>(({ uiTheme, size, theme }) => ({
  textDecoration: 'none',
  color: colors.text,
  '& .inner': {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: MERCH_CARD_SIZE[size].desktop,
    [theme.breakpoints.between('md', 'lg')]: {
      width: MERCH_CARD_SIZE[size].tablet,
    },
    [theme.breakpoints.between('sm', 'md')]: {
      width: MERCH_CARD_SIZE[size].mobile,
    },
    [theme.breakpoints.down('sm')]: {
      width: MERCH_CARD_SIZE[size].smMobile,
    },
    borderRadius: 6,
    '& .imgCon': {
      display: 'flex',
      justifyContent: 'column',
      alignItems: 'center',
      height: MERCH_CARD_SIZE[size].desktop,
      [theme.breakpoints.between('md', 'lg')]: {
        height: MERCH_CARD_SIZE[size].tablet,
      },
      [theme.breakpoints.between('sm', 'md')]: {
        height: MERCH_CARD_SIZE[size].mobile,
      },
      [theme.breakpoints.down('sm')]: {
        height: MERCH_CARD_SIZE[size].smMobile,
      },
      '& img': {
        borderRadius: 8,
        width: MERCH_CARD_SIZE[size].desktop,
        maxHeight: MERCH_CARD_SIZE[size].desktop,
        [theme.breakpoints.between('md', 'lg')]: {
          width: MERCH_CARD_SIZE[size].tablet,
          maxHeight: MERCH_CARD_SIZE[size].tablet,
        },
        [theme.breakpoints.between('sm', 'md')]: {
          width: MERCH_CARD_SIZE[size].mobile,
          maxHeight: MERCH_CARD_SIZE[size].mobile,
        },
        [theme.breakpoints.down('sm')]: {
          width: MERCH_CARD_SIZE[size].smMobile,
          maxHeight: MERCH_CARD_SIZE[size].smMobile,
        },
        objectFit: 'contain',
        backgroundColor: 'transparent',
        margin: '10px 0 10px 0',
      },
    },
    '& .price': {
      margin: 3,
      fontSize: fontSizes.medium,
      color: uiTheme === 'dark' ? colors.white : colors.text,
      fontWeight: 800,
      [theme.breakpoints.down('md')]: {
        fontSize: fontSizes.small,
      },
    },
  },
}))
